<template>
  <v-tooltip bottom>
    <template #activator="{ on, attrs }">
      <AppChip
        class-list="ml-1"
        color="edit"
        text-color="white--text"
        v-bind="attrs"
        v-on="on"
      >
        {{ $t("people:personPage.hasDebts.label", "Debts") }}
      </AppChip>
    </template>
    <span>{{
      $t(
        "people:personPage.hasDebts.hint",
        "Outstanding payments. Check Shopping Basket for details"
      )
    }}</span>
  </v-tooltip>
</template>
<script>
import gql from "fraql";
import { defineComponent } from "vue";
import AppChip from "@elements/AppChip.vue";

/*#__PURE__*/
export default defineComponent({
  name: "AppShowPersonDebtsBadge",
  components: {
    AppChip
  },
  fragments: {
    personFields: gql`
      fragment _ on Person {
        hasDebts
      }
    `
  }
});
</script>
